import React, { useEffect, useState } from 'react'

import AppProvider, { useAppState } from './state/app.state'
import AuthProvider from './state/auth.state'
import RouterProvider from './state/route.state'
import TranslationProvider from './translation/provider'

import ThreeCanvas from './components/canvas.component'
import UIContainer from './components/ui/ui.component'
import CartContainer from './components/cart/index'
import { BASE_URL } from './utils/helpers.util'
import Cookies from 'js-cookie'

import axios from 'axios'
export default function App() {

  const [localizationData, setLocalizationData] = useState({
    locales: ["en", "it"],
    localizations: {en:{}, it:{}},
    defaultLanguage: "it",
    loaded: false
  })

  function localizationsToArray(localizations){
    return Object.keys(localizations).map(locale => localizations[locale])
  }

  function trimLocalizations(data) {

    const locales = data.SupportedLocales
    const localizations = data.Localizations

    const updated = {}

    for (const locale of locales) {
      const d = localizations[locale]
      const keys = Object.keys(d)
      keys.forEach(k => {
        if (k.indexOf("site_") != 0) delete d[k]
      })
      updated[locale] = d
    }

    return {
      localizations: updated, locales
    }

  }

  async function fetchTranslations() {
    try {

      const defaultLang = Cookies.get("lang") ?? "it"

      const req = await axios.get(BASE_URL + "/globals", {
        headers: {
          "x-api-key": "ycz66w3M5S4SOR57O5QqEkq8w4/dewwnGJ7WTA=="
        }
      })

      const {localizations, locales} = trimLocalizations(req.data)

      setLocalizationData(old => {
        return {
          ...old,
          locales,
          defaultLanguage: defaultLang,
          localizations: localizations
        }
      })


    } catch (err) {
      console.log(err)
    }
  }
  useEffect(() => {
    fetchTranslations()
    console.log(localizationData)
  }, [])
  return (
    <TranslationProvider languages={localizationData.locales} translations={localizationsToArray(localizationData.localizations)} selectedLanguage={localizationData.defaultLanguage} >
    <AuthProvider>
      <AppProvider>
        <RouterProvider>
          <CartContainer />
          <UIContainer />
          <ThreeCanvas />
        </RouterProvider>
      </AppProvider>
    </AuthProvider>
    </TranslationProvider>
  )
}
